export default __webpack_public_path__ + "static/media/bedroom1.97fc57ae.jpg";